var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('router-view'),_c('div',{class:[
      'toolbar-mobile-vs',
      _vm.isActiveRoute('/videos') ? 'bg-toolbar-mobile-video border-none' : '',
      _vm.isActiveRoute('/pages/login') ||
      _vm.isActiveRoute('/pages/register') ||
      _vm.isActiveRoute('/checkout') ||
      _vm.isActiveRoute('/mobile/whatsapp-chat') ||
      _vm.isActiveRoute('/mobile/instagram-chat') ||
      _vm.isActiveRoute('/checkout/payment') ||
      _vm.isActiveRoute('/checkout/complete')
        ? 'hidden'
        : 'lg:hidden flex',
    ]},[_c('div',{class:[
        'toolbar-icon px-4 flex items-center justify-center',
        _vm.isActiveRoute('/dispositivo') ? 'toolbar-active' : '',
      ],on:{"click":function($event){return _vm.navigateTo('/dispositivo')}}},[_c('feather-icon',{attrs:{"icon":"GridIcon","svg-classes":"w-7 h-7"}})],1),_c('div',{class:[
        'toolbar-icon px-4 flex items-center justify-center',
        _vm.isActiveRoute('/videos') ? 'toolbar-active' : '',
      ],on:{"click":function($event){return _vm.navigateTo('/videos')}}},[_c('feather-icon',{attrs:{"icon":"VideoIcon","svg-classes":"w-7 h-7"}})],1),_c('div',{class:[
        'toolbar-icon px-4 flex items-center justify-center',
        _vm.isActiveRoute('/marketplace') ? 'toolbar-active' : '',
      ],on:{"click":function($event){return _vm.navigateTo('/marketplace')}}},[_c('feather-icon',{attrs:{"icon":"ShoppingCartIcon","svg-classes":"w-7 h-7"}})],1)]),_vm._m(0)],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('a',{staticClass:"wpp",attrs:{"href":"https://wa.me/551132300769?text=Detetive%2C%20preciso%20de%20ajuda!"}},[_c('img',{staticStyle:{"width":"50%","height":"50%"},attrs:{"src":require("@/assets/images/pages/whatsapp.svg"),"alt":"Logo"}})])
}]

export { render, staticRenderFns }